// This file was automatically generated from button.html.
// Please don't edit this file by hand.

goog.provide('el8.template.button');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.className = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isRealButton) ? 'el8PrimaryButton ebs-btn ebs-btn-primary' : (opt_data.hasDropdown) ? 'el8DropdownButton' : 'el8SecondaryButton ebs-btn ebs-btn-default');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.hiddenIfReadonly = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((el8Globals.READ_ONLY && ! opt_data.allowReadonly) ? 'hidden' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.button = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="', (opt_data.buttonClass) ? soy.$$escapeHtml(opt_data.buttonClass) : 'el8ButtonItem', ' ');
  el8.template.button.hiddenIfReadonly(opt_data, output);
  output.append('">');
  if (opt_data.isLink) {
    output.append('<a', (opt_data.customText) ? ' ' + soy.$$escapeHtml(opt_data.customText) : '', ' class="el8DialogLink ', soy.$$escapeHtml(opt_data.htmlClass), (opt_data.hasDropdown) ? ' am-highlight' : '', '"', (opt_data.feedItemId) ? ' _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '"' : '', '>', soy.$$escapeHtml(opt_data.name), (opt_data.hasDropdown) ? '<span class="el8DownArrowIcon"></span>' : '', '</a>');
  } else {
    output.append('<button type="button"', (opt_data.customText) ? ' ' + soy.$$escapeHtml(opt_data.customText) : '', ' class="el8button ');
    el8.template.button.className(opt_data, output);
    output.append(' ', soy.$$escapeHtml(opt_data.htmlClass), (opt_data.hasDropdown) ? ' am-highlight' : '', ' ');
    el8.template.button.hiddenIfReadonly(opt_data, output);
    output.append('" ', (opt_data.feedItemId) ? '_fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '"' : '', ' >', soy.$$escapeHtml(opt_data.name), (opt_data.hasDropdown) ? '<span class="el8ButtonDropdownIcon el8Show"></span>' : '', '</button>');
  }
  output.append('</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.buttons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div ', (opt_data.containerId) ? 'id="' + soy.$$escapeHtml(opt_data.containerId) + '"' : '', ' class="el8DialogButtonContainer"><ul class="', (opt_data.ulClass) ? soy.$$escapeHtml(opt_data.ulClass) : 'el8ButtonContainer', '">');
  var buttonList10060 = opt_data.buttons;
  var buttonListLen10060 = buttonList10060.length;
  for (var buttonIndex10060 = 0; buttonIndex10060 < buttonListLen10060; buttonIndex10060++) {
    var buttonData10060 = buttonList10060[buttonIndex10060];
    el8.template.button.button(soy.$$augmentData(buttonData10060, {feedItemId: opt_data.feedItemId}), output);
  }
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.feedButtonItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isAlone) {
    el8.template.button.feedButton(soy.$$augmentData(opt_data, {styleClass: 'el8AloneButton'}), output);
  } else {
    output.append('<li class="', (opt_data.index + 1 == 1) ? 'el8ShortcutBarButtonItemFirst' : (opt_data.index + 1 == opt_data.count) ? 'el8ShortcutBarButtonItemLast' : 'el8ShortcutBarButtonItem', '">');
    if (opt_data.index + 1 == 1) {
      el8.template.button.feedButton(soy.$$augmentData(opt_data, {styleClass: 'el8FirstButton'}), output);
    } else if (opt_data.index + 1 == opt_data.count) {
      el8.template.button.feedButton(soy.$$augmentData(opt_data, {styleClass: 'el8LastButton'}), output);
    } else {
      el8.template.button.feedButton(soy.$$augmentData(opt_data, {styleClass: 'el8MiddleButton'}), output);
    }
    output.append('</li>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.feedButton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.hasDropdown) {
    output.append('<button type="button" class="el8button el8FeedDropdownButton ebs-btn ebs-btn-default ', soy.$$escapeHtml(opt_data.styleClass), (opt_data.htmlClass) ? ' ' + soy.$$escapeHtml(opt_data.htmlClass) : '', ' ');
    el8.template.button.hiddenIfReadonly(opt_data, output);
    output.append('"', (opt_data.feedItemId) ? ' _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '"' : '', '>', soy.$$escapeHtml(opt_data.name), '<span class="el8ButtonDropdownIcon el8FeedButtonDropdownPosition"></span></button>');
  } else {
    output.append('<button type="button" class="el8button el8FeedButton ebs-btn ebs-btn-default ', soy.$$escapeHtml(opt_data.styleClass), (opt_data.htmlClass) ? ' ' + soy.$$escapeHtml(opt_data.htmlClass) : '', ' ');
    el8.template.button.hiddenIfReadonly(opt_data, output);
    output.append('"', (opt_data.feedItemId) ? ' _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '"' : '', '>', soy.$$escapeHtml(opt_data.name), '</button>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.button.feedButtonList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.buttons.length == 1) {
    el8.template.button.feedButtonItem(soy.$$augmentData(opt_data.buttons[0], {isAlone: true, feedItemId: opt_data.feedItemId}), output);
  } else {
    output.append('<ul class="el8ButtonContainer">');
    var buttonList10137 = opt_data.buttons;
    var buttonListLen10137 = buttonList10137.length;
    for (var buttonIndex10137 = 0; buttonIndex10137 < buttonListLen10137; buttonIndex10137++) {
      var buttonData10137 = buttonList10137[buttonIndex10137];
      el8.template.button.feedButtonItem(soy.$$augmentData(buttonData10137, {index: buttonIndex10137, count: opt_data.buttons.length, feedItemId: opt_data.feedItemId}), output);
    }
    output.append('</ul>');
  }
  if (!opt_sb) return output.toString();
};
